import * as React from 'react';

import { footerBaseCss } from './styles';

export interface ModalFooterProps {
  className?: string;
  children?: React.ReactNode;
  tag?: React.ElementType;
}

const ModalFooter = ({ className, children, tag: Tag = 'div' }: ModalFooterProps): React.JSX.Element => (
  <Tag css={footerBaseCss} className={className}>
    {children}
  </Tag>
);

export default ModalFooter;
